import { createMainResourceREST } from '../resource';
import {
  CRProjectViewerItem,
  CRProjectViewerItemAPI,
  CRProjectViewerKey,
  ProjectViewerActions,
} from './types';

type AnyProjectViewer = CRProjectViewerKey | CRProjectViewerItem | undefined;

function sameKeyProjectViewer(
  a: AnyProjectViewer,
  b: AnyProjectViewer,
): boolean {
  return a?.projectToken === b?.projectToken;
}

function getEndpointProjectViewer() {
  return `/viewer-design-project/`;
}

function parseProjectViewer(
  projectViewer: CRProjectViewerItemAPI,
): CRProjectViewerItem {
  const {
    project: {
      chargeable: { hardware, ...chargeable },
      ...project
    },
    branch,
  } = projectViewer;

  return { project, chargeable, hardware, branch };
}

function mergeProjectViewer(
  last: CRProjectViewerItem,
  current: CRProjectViewerItem,
) {
  return current;
}

function mergeSummaryBody(
  oldSummary?: CRProjectViewerItem,
  currentBody?: CRProjectViewerItem,
) {
  return (currentBody ?? oldSummary)!;
}

const projectViewerStateSelector = (state: any) => state.projectViewer;

const projectViewerSelector = (state: any): CRProjectViewerItem | undefined =>
  state.projectViewer?.currentBody;

const { actions, reducer, watches } = createMainResourceREST(
  'viewer-design-project',
  getEndpointProjectViewer,
  projectViewerStateSelector,
  sameKeyProjectViewer,
  parseProjectViewer,
  parseProjectViewer,
  mergeProjectViewer,
  mergeSummaryBody,
);

const projectViewerActions: ProjectViewerActions = actions;
export {
  projectViewerActions,
  projectViewerSelector,
  reducer as projectViewerReducer,
  watches as projectViewerWatches,
};

export * from './types';
